import { render, staticRenderFns } from "./OkrOverviewCard.vue?vue&type=template&id=f54e8382"
import script from "./OkrOverviewCard.vue?vue&type=script&lang=js"
export * from "./OkrOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./OkrOverviewCard.vue?vue&type=style&index=0&id=f54e8382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports